<template>
  <div>
    <div class="w100 h-bar" layout="column top-left">
      <score-bar-h :city="city" :maxScore="maxScore" v-for="city in cities" />
    </div>

    <div class="w100 v-bar" layout="row top-spread">
      <score-bar-v :city="city" :maxScore="maxScore" v-for="city in cities" />
    </div>
  </div>
</template>

<script>

    import BackendProxy from '@/BackendProxy';
    import ScoreBarH from "./ScoreBarH";
    import ScoreBarV from "./ScoreBarV";


    export default {
      components: {ScoreBarH, ScoreBarV},
      data() {
        return {
          cities: BackendProxy.instance.cities,
          maxScore: BackendProxy.instance.maxScore
        }
      },
      methods: {

      },
      name: "score-bars"
    }
</script>

<style lang="scss" scoped>

  $min-width: 600px;

  .h-bar {
    margin-bottom: 2rem;
    cursor: pointer;
    @media screen and (min-width: $min-width) {
        display: none;
    }
  }

  .v-bar {
    margin-bottom: 7rem;
    cursor: pointer;
    @media screen and (max-width: $min-width) {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/blocks/ScoreBars.vue